import MDButton from 'components/MDButton'
import React, { useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack } from '@mui/material'
import Editor from 'components/editor'
const CreateModal = ({ handleRefresh }) => {
  const [agency] = useAgencyInfo()
  const uploadImage = useUploadImage()

  const [description, setDescription] = useState('')
  const [awardDescription, setAwardDescription] = useState('')
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleModal = () => setOpenAddProduct(true)
  const closeAddProduct = () => setOpenAddProduct(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    let image_response = null

    // Attempt to upload image, if image is provided
    if (e.target?.image?.files?.[0]) {
      try {
        image_response = await uploadImage({
          file: e.target?.image?.files?.[0],
          desiredPath: `app/logo/image`,
        })
      } catch (error) {
        console.error('Image upload failed:', error)
      }
    }

    // Prepare payload with or without image
    const payload = {
      name: e.target.name.value,
      award_name: e.target.award_name.value,
      award_description: awardDescription,
      description: description,
      status: e.target.status.value,
      points: e.target.points.value,
      image: image_response?.response?.data || null,
      type: e.target.type.value,
    }

    try {
      const { response } = await AppService.onboardlistcategory.create({ payload })

      if (response) {
        setProcessing(false)
        closeAddProduct()
        handleRefresh()
      }
    } catch (error) {
      console.error('Error creating category:', error)
      setProcessing(false)
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>

      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Onboard Category
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Award Name</MDTypography>
              <MDInput label="Award Name" name="award_name" fullWidth />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Award Description</MDTypography>
              <MDInput label="Award Description" name="award_description" fullWidth />
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Award Description</MDTypography>
              <Editor handleChange={setAwardDescription} />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <MDInput label="Description" name="description" fullWidth />
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput select name="type" fullWidth required SelectProps={{ native: true }}
                defaultValue="agency"
              >
                <option value="agency">Agency</option>
                <option value="location">Location</option>
                <option value="levelupmarketplace">LevelUpMarketplace</option>
                <option value="appcreator">Appcreator</option>
              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                defaultValue="Publish"
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
             <MDBox mb={2}>
                          <MDTypography variant="button">Type</MDTypography>
                          <MDInput select name="type" fullWidth required SelectProps={{ native: true }}
                            defaultValue="agency"
                          >
                            <option value="agency">Agency</option>
                            <option value="location">Location</option>
                          </MDInput>
                        </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>

            <MDBox mb={2}>
              <MDTypography variant="button">Point Number</MDTypography>
              <MDInput label="Point Number" name="points" fullWidth required />
            </MDBox>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
